import React from 'react';
import { AssessmentsContentLoading } from 'components/AssessmentsContentLoading/AssessmentsContentLoading';
import { AssessmentsErrorState } from 'components/AssessmentsErrorState/AssessmentsErrorState';

import { AssessmentsCompleted } from 'components/AssessmentsCompleted/AssessmentsCompleted';
import { AssessmentsSaveAndClose } from 'components/AssessmentsSaveAndClose/AssessmentsSaveAndClose';
import { AssessmentsContent } from 'components/AssessmentsContent/AssessmentsContent';
import { useLoadAssessments } from 'features/assessments/hooks/useLoadAssessments';
import { useAssessmentsAuth } from 'features/assessments/hooks/useAssessmentsAuth';

interface AssessmentsProps {
  // Called instead of ending the campaign session, when assessments run inside the checklist
  onExit?: () => void;
}

export const Assessments = ({ onExit }: AssessmentsProps) => {
  const { loading, error, retryLoadAssessments, saveCompleted, saveAndCloseCompleted } =
    useLoadAssessments();
  const { logoutAssessments } = useAssessmentsAuth();

  if (loading) {
    return <AssessmentsContentLoading />;
  }

  if (error) {
    return <AssessmentsErrorState onRetryClick={retryLoadAssessments} />;
  }

  if (saveCompleted) {
    return <AssessmentsCompleted />;
  }

  if (saveAndCloseCompleted) {
    return <AssessmentsSaveAndClose backHome={onExit ?? logoutAssessments} />;
  }

  return <AssessmentsContent />;
};
